import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ShoppingBag, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";

const fmt = (c) => `$${(c / 100).toFixed(2)}`;

export default function ProductDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const { add } = useCart();

  useEffect(() => {
    api.get(`/products/${id}`).then((r) => setP(r.data)).catch(() => setP(false));
  }, [id]);

  if (p === null) return <div className="p-20 text-center text-slate-500">Loading…</div>;
  if (!p) return <div className="p-20 text-center text-slate-500">Product not found.</div>;

  return (
    <div className="mx-auto max-w-6xl px-5 py-12 md:px-8 md:py-16">
      <Link to="/shop" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-cyan-700" data-testid="product-back-link">
        <ArrowLeft className="h-4 w-4" /> Back to shop
      </Link>
      <div className="mt-6 grid gap-10 md:grid-cols-2">
        <div className="overflow-hidden rounded-3xl border border-cyan-100 bg-white">
          {p.image_url ? <img src={p.image_url} alt={p.name} className="h-full w-full object-cover" /> : null}
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700">{p.category}</span>
          <h1 className="mt-2 font-display text-3xl font-bold text-slate-900 md:text-4xl">{p.name}</h1>
          <div className="mt-3 font-display text-3xl font-bold text-cyan-700">{fmt(p.price_cents)}</div>
          <p className="mt-5 text-slate-600">{p.description}</p>
          <div className="mt-2 text-sm text-slate-500">{p.stock > 0 ? `${p.stock} in stock` : "Out of stock"}</div>
          <div className="mt-6">
            <Button onClick={() => add(p)} className="btn-aqua" data-testid="product-detail-add-button">
              <ShoppingBag className="h-4 w-4" /> Add to cart
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
